<script lang="ts" setup>
import IconChevronRight from '@lahaus-roomie/roomie/src/assets/icons/chevron-right.svg'

import type { Props } from './types'

import './_index.scss'

defineProps<Props>()

const { t, n } = useI18n()
</script>

<script lang="ts">
export default {
  name: 'AppAiChatRecommendationCard'
}
</script>

<template>
  <div class="chat-recommendation-card p-8 flex">
    <div class="chat-recommendation-card__cover-container pointer-events-none">
      <img
        class="object-cover w-[100px] h-[100px] pointer-events-none"
        :src="coverImage"
        :alt="t('coverAlt', { name })"
        width="100"
        height="100">
    </div>

    <div class="chat-recommendation-card__info-container p-10 flex-1 pointer-events-none">
      <span class="text-12 text-brand-600">
        {{ t('title') }}
      </span>

      <h3 class="font-semibold mb-8">
        {{ name }}
      </h3>

      <p class="text-14 font-medium">
        {{ t('priceDescription', { price: n(minPrice, 'currency') }) }} {{ currency }}
      </p>
    </div>

    <div class="flex items-center pointer-events-none">
      <IconChevronRight class="w-24 h-24 fill-accent-600" />
    </div>
  </div>
</template>

<i18n src="./i18n.json" />
